<div class="brand-toolbar mat-elevation-z3 flex-row flex-align-start-center">
    <!-- <mat-icon>view_compact</mat-icon> -->
    <a class="logo-text" routerLink="/dashboard">Registrul Medicilor</a>
  </div>